<template>
  <v-container class="sp">
    <v-row>
      <v-col col="12">
        <h1 class="font-h1-sp font-weight-bold mb-3 title-border" v-text="title"></h1>
        <div v-html="body"></div>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" class="text-center">
        <v-btn
          rounded
          large
          dark
          align-items="center"
          color="gray"
          width="250"
          class="font-weight-bold text-capitalize"
          @click="$router.push(nextRoute)"
        >
          {{ this.$route.params.lang === 'en' ? '日本語' : 'english' }}
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import AppText from '@/constants/app-text'

export default {
  computed: {
    title() {
      console.log(AppText)
      console.log('TEST')
      console.log(this.$route)
      if (this.$route.name === 'AppTos') {
        return this.$route.params.lang === 'en'
          ? 'Terms of Service'
          : '利用規約'
      } else {
        return this.$route.params.lang === 'en'
          ? 'Privacy Policy'
          : 'プライバシーポリシー'
      }
    },
    body() {
      if (this.$route.name === 'AppTos') {
        return AppText.tos[this.$route.params.lang]
      } else {
        return AppText.pp[this.$route.params.lang]
      }
    },
    nextRoute() {
      if (this.$route.name === 'AppTos') {
        return `/app/tos/${this.$route.params.lang === 'en' ? 'ja' : 'en'}` 
      } else {
        return `/app/privacy/${this.$route.params.lang === 'en' ? 'ja' : 'en'}` 
      }
    }
  },
};
</script>

<style lang="stylus">
p
  line-height 1.5
  font-size 15px

.sp
  p, ul, ol
    font-size 12px

ol.list_parentheses
  padding 0 0 0 2em
  margin 0
  li
    list-style-type none
    list-style-position inside
    counter-increment cnt
    padding-left 1.5em
    text-indent -1.5em
    &:before
      display marker
      content "(" counter(cnt) ") "

ul
  margin-left 1em
</style>
